module.exports = __webpack_public_path__ + "media/images/pic/hero/buildings-73fce1ab66adbfbf1f63f19daf0197d2.webp";